export const reduxKey = '@@devpage';
export const actionKey = '@@devpage';
export const defaultState = {
    viewOptions: {
        visiblePanel: false,
        activeActionBar: 'primary'
    },
    secondaryContentLoaderState: {
        relatedContent: {},
        preloadIds: []
    }
};
